import type { QueryClient, QueryKey } from '@tanstack/react-query';

/**
 * Call after a write, instead of a bare `invalidateQueries`. A bare invalidate does not restart a query whose FIRST
 * fetch is still running (a screen opened right after the write, or a list just opened by typing in the search box):
 * it joins that fetch, which may have read the data before the write committed, and the old data stays on screen.
 * So reads in flight under `queryKey` are cancelled first and then fetched again.
 */
export async function refreshQueries(queryClient: QueryClient, queryKey: QueryKey): Promise<void> {
  await queryClient.cancelQueries({ queryKey });
  await queryClient.invalidateQueries({ queryKey });
}
